export default "__VITE_ASSET__0fKA0bkD__"